import React from 'react';
import { C } from './theme';

const Phone = ({ children }: { children: React.ReactNode }) => (
    <div style={{
        minHeight: "100vh",
        width: "100%",
        background: C.bg,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        fontFamily: C.font,
        WebkitFontSmoothing: "antialiased",
    }}>
        {children}
    </div>
);

export default Phone;

